import React from 'react';
import T from 'prop-types';
import SimpleFormat from '@16g/react-simple-format';
import { get } from 'lodash-es';

import skeletons from './Skeletons';
import ShowMoreLess from '../../../../../components/ShowMoreLess';

const InsightsDescription = ({ details, settings }) => {
  const about_data = get(details, 'app_about.about_data');
  const description = get(about_data, 'description');
  const subtitle = get(about_data, 'subtitle');

  if (settings.pending) return skeletons.detailsDescription;

  return (
    <div className="insights-details-block">
      <h4 className="insights-details-block__head h4">Description</h4>
      <h4 className="insights-details-block__subtitle">{subtitle}</h4>
      <div className="insights-details-block__text insights-details-block__description">
        <ShowMoreLess collapsedHeight={44} showMoreText="Show More" showLessText="Show Less">
          <SimpleFormat text={description} />
        </ShowMoreLess>
      </div>
    </div>
  );
};

InsightsDescription.propTypes = {
  details: T.object,
  settings: T.object,
};

export default InsightsDescription;
